<template>
  <div class="faceboxes">
    <h1 class="flex-clear">{{aka|capitalize|plural}}</h1>
    <p v-if="!entitiesHaveLoaded">Loading {{aka|plural}}...</p>
    <EntityCard
      v-for="entity in sortedEntities"
      :key="entity.id"
      :class="{taken: entity.isActive}"
      :entity="entity"
      :deleteEntity="deleteEntity"
      :selectEntity="selectEntity"
      :playerIsGM="playerIsGM"
      >
    </EntityCard>
    <div class="flex-clear" v-if="entitiesHaveLoaded && playerIsGM">
      <p>Add a New {{aka|capitalize}} Here</p>
      <a href="" class="btn-floating btn-large pink">
        <router-link :to="{ name: 'AddEntity', props: {entityType: 'monster'} }" class="btn-floating btn-large pink">
          <i class="material-icons">add</i>
        </router-link>
      </a>
    </div>
  </div>
</template>

<script>
import EntityCard from '@/components/EntityCard'

export default {
  name: 'EntityList',
  props: [
    'entities',
    'entitiesHaveLoaded',
    'aka',
    'selectEntity',
    'deleteEntity',
    'playerIsGM',
    ],
  components: {EntityCard},
  filters: {
    capitalize: (value) => {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    plural: (value) => {
      if (!value) return ''
      if (value.charAt(value.length-1) == 's') return value + 'es'
      return value + 's'
    }
  },
  methods: {
    sortList(list){
      return list.sort((a,b) => {
        let ea = a.name
        let eb = b.name
        if(ea < eb){
          return -1
        }
        return 1
      })
    }
  },
  computed: {
    sortedEntities() {
      return this.sortList(this.entities)
    }
  }
}
</script>

<style scoped>
.faceboxes{
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/EntityList.vue